
import { PlatformLocation } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { OutOfJurisdictionRegistrationModel } from '@max/commercialpermitting/models/out-of-jurisdiction-registration.model';
import { CommercialOutOfJurisdictionRegistrationService } from '@max/commercialpermitting/services/commercial-out-of-Jurisdiction-registration.service';
import { CommercialPermitService } from '@max/commercialpermitting/services/commercial-permit.service';
import { IJurisdiction, Jurisdiction } from '@max/foundation/models/enums/jurisdiction.enum';
import { BaseComponent } from '@max/shared/base-components/base.component';
import * as moment from 'moment';
import { map } from 'rxjs/operators';

export class OutOfJurisdictionRegistrationModalData {
    constructor(public outOfJurisdictionRegistration: OutOfJurisdictionRegistrationModel, public modalType: string, public vehicleId: number, public edit: boolean = false) {}
}

@Component({
    selector: 'out-of-jurisdiction-registration-modal',
    templateUrl: './out-of-jurisdiction-registration-modal.html'
})
export class OutOfJurisdictionRegistrationModalComponent extends BaseComponent {
    public pageData: any = {};
    public dataLoaded = false;
    public modalType: string;
    public form: UntypedFormGroup;
    public jurisdictions: IJurisdiction[] = new Jurisdiction().GetActive().filter(jurisdiction => jurisdiction.id !== 4);
    public edit = false;

    constructor(
        public dialogRef: MatDialogRef<OutOfJurisdictionRegistrationModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: OutOfJurisdictionRegistrationModalData,
        private formBuilder: UntypedFormBuilder,
        private outOfJurisdictionRegistrationService: CommercialOutOfJurisdictionRegistrationService
    ){
        super();
        this.modalType = data.modalType;
        this.edit = data.edit;
    }

    public ngOnInit() {
        this.form = this.formBuilder.group({
            plateNumber: [null, Validators.required],
            expirationDate: [moment(), Validators.required],
            jurisdictionId: [null, Validators.required],
        });

        if (this.edit) {
            this.form.controls['plateNumber'].setValue(this.data.outOfJurisdictionRegistration.plateNumber);
            this.form.controls['expirationDate'].setValue(this.data.outOfJurisdictionRegistration.expirationDate);
            this.form.controls['jurisdictionId'].setValue(this.data.outOfJurisdictionRegistration.jurisdictionId);

        }

        this.dataLoaded = true;
    }

    public cancel() {
        this.dialogRef.close(false);
    }

    public save() {
        const model = new OutOfJurisdictionRegistrationModel();
        model.active = true;
        model.expirationDate = new Date(this.form.controls['expirationDate'].value);
        model.jurisdictionId = this.form.controls['jurisdictionId'].value;
        model.plateNumber = this.form.controls['plateNumber'].value;
        model.vehicleId = this.data.vehicleId;

        this.outOfJurisdictionRegistrationService.saveOutOfJurisdictionRegistration(model).subscribe(r => {
            if (r && r > 0) {
                return this.dialogRef.close(true);
            }

            return this.dialogRef.close(false);
        });
    }

}
